query TAGS {
  tags {
    items {
      id
      name
    }
  }
}
